import { Button } from "@capacit-com/lara-law-shared-ui";
import { cn } from "@/lib/utils";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@capacit-com/lara-law-shared-ui";
import { BrainCircuitIcon } from "lucide-react";
import { FC, useState } from "react";
import { getDomain, getDomainName } from "@/utils/domain";
type Props = {
  useChainOfThought: boolean;
  handleChainOfThoughtClick: () => void;
  disabled: boolean;
};

const ChainOfThoughtButton: FC<Props> = ({
  useChainOfThought,
  handleChainOfThoughtClick,
  disabled,
}) => {
  const [tooltipVisible, setTooltipVisible] = useState(false);
  const domainName = getDomainName(getDomain(window.location.hostname));

  return (
    <Tooltip>
      <TooltipTrigger
        asChild
        onPointerEnter={disabled ? undefined : () => setTooltipVisible(true)}
        onPointerLeave={disabled ? undefined : () => setTooltipVisible(false)}
      >
        <Button
          variant="ghost"
          size="sm"
          className="px-2.5 py-5"
          onClick={() => {
            if (!disabled) {
              handleChainOfThoughtClick();
            }
          }}
          disabled={disabled}
        >
          <div className="relative" style={{ width: "20px", height: "20px" }}>
            {useChainOfThought && (
              <BrainCircuitIcon
                size={20}
                style={{ width: "20px", height: "20px" }}
                className={cn(
                  "absolute animate-[ping_1s_ease-in-out] text-primary"
                )}
              />
            )}
            <BrainCircuitIcon
              size={20}
              style={{ width: "20px", height: "20px" }}
              className={cn(
                "prompt-library-icon",
                useChainOfThought && "text-primary border-b-primary"
              )}
            />
          </div>
        </Button>
      </TooltipTrigger>
      {tooltipVisible && (
        <TooltipContent>
          <p>{domainName}'s tankeproces</p>
        </TooltipContent>
      )}
    </Tooltip>
  );
};

export default ChainOfThoughtButton;
